module.exports = {
      id: "account-stats-usage",
      viewBox: "0 0 21.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#account-stats-usage",
      toString: function () {
        return this.url;
      }
    }